export function getAppSyncEndpoint(region) {
  return process.env.VUE_APP_DEXTR_APPSYNC_ENDPOINT.replace("{region}", region);
}
